import { forwardRef } from 'react';

//* Provider
import { LanguageConsumer } from '../providers/LanguageProvider';

//* Helpers
import getContext from '@/lib/get-context';

export default function withLanguageContext(ConnectedComponent, properties = []) {
    return forwardRef((props, ref) => {
        return (
            <LanguageConsumer>
                {(context) => {
                    const contextProps = properties.length ? getContext(context, properties) : {};

                    return (
                        <ConnectedComponent
                            ref={ref}
                            {...props}
                            {...contextProps}
                        />
                    );
                }}
            </LanguageConsumer>
        );
    });
}
